module.exports = "/packs/coaching_renewal_popup-pc-22c2dd5391883e8d4fbe7e028d2edce8.png";